/* tslint:disable */
/* eslint-disable */
/**
 * WICSSend
 * API reference documentation for WICSSend
 *
 * The version of the OpenAPI document: 0.1.0-RC
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
/**
 * CarrierApi - axios parameter creator
 * @export
 */
export const CarrierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} carrierCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppCarrierGet: async (carrierCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierCode' is not null or undefined
            assertParamExists('getAppCarrierGet', 'carrierCode', carrierCode)
            const localVarPath = `/api/carrier/{carrierCode}`
                .replace(`{${"carrierCode"}}`, encodeURIComponent(String(carrierCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppCarrierList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/carrier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppCarrierList_1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/carrier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppCarrierDisable: async (carrierCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierCode' is not null or undefined
            assertParamExists('postAppCarrierDisable', 'carrierCode', carrierCode)
            const localVarPath = `/api/carrier/{carrierCode}/disable`
                .replace(`{${"carrierCode"}}`, encodeURIComponent(String(carrierCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppCarrierEnable: async (carrierCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierCode' is not null or undefined
            assertParamExists('postAppCarrierEnable', 'carrierCode', carrierCode)
            const localVarPath = `/api/carrier/{carrierCode}/enable`
                .replace(`{${"carrierCode"}}`, encodeURIComponent(String(carrierCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarrierApi - functional programming interface
 * @export
 */
export const CarrierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarrierApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} carrierCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppCarrierGet(carrierCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppCarrierGet(carrierCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierApi.getAppCarrierGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppCarrierList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppCarrierList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierApi.getAppCarrierList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppCarrierList_1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppCarrierList_1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierApi.getAppCarrierList_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAppCarrierDisable(carrierCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAppCarrierDisable(carrierCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierApi.postAppCarrierDisable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAppCarrierEnable(carrierCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAppCarrierEnable(carrierCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierApi.postAppCarrierEnable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CarrierApi - factory interface
 * @export
 */
export const CarrierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarrierApiFp(configuration)
    return {
        /**
         * 
         * @param {CarrierApiGetAppCarrierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppCarrierGet(requestParameters: CarrierApiGetAppCarrierGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAppCarrierGet(requestParameters.carrierCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppCarrierList(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAppCarrierList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppCarrierList_1(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAppCarrierList_1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierApiPostAppCarrierDisableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppCarrierDisable(requestParameters: CarrierApiPostAppCarrierDisableRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postAppCarrierDisable(requestParameters.carrierCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierApiPostAppCarrierEnableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppCarrierEnable(requestParameters: CarrierApiPostAppCarrierEnableRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postAppCarrierEnable(requestParameters.carrierCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAppCarrierGet operation in CarrierApi.
 * @export
 * @interface CarrierApiGetAppCarrierGetRequest
 */
export interface CarrierApiGetAppCarrierGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CarrierApiGetAppCarrierGet
     */
    readonly carrierCode: string
}

/**
 * Request parameters for postAppCarrierDisable operation in CarrierApi.
 * @export
 * @interface CarrierApiPostAppCarrierDisableRequest
 */
export interface CarrierApiPostAppCarrierDisableRequest {
    /**
     * 
     * @type {string}
     * @memberof CarrierApiPostAppCarrierDisable
     */
    readonly carrierCode: string
}

/**
 * Request parameters for postAppCarrierEnable operation in CarrierApi.
 * @export
 * @interface CarrierApiPostAppCarrierEnableRequest
 */
export interface CarrierApiPostAppCarrierEnableRequest {
    /**
     * 
     * @type {string}
     * @memberof CarrierApiPostAppCarrierEnable
     */
    readonly carrierCode: string
}

/**
 * CarrierApi - object-oriented interface
 * @export
 * @class CarrierApi
 * @extends {BaseAPI}
 */
export class CarrierApi extends BaseAPI {
    /**
     * 
     * @param {CarrierApiGetAppCarrierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    public getAppCarrierGet(requestParameters: CarrierApiGetAppCarrierGetRequest, options?: RawAxiosRequestConfig) {
        return CarrierApiFp(this.configuration).getAppCarrierGet(requestParameters.carrierCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    public getAppCarrierList(options?: RawAxiosRequestConfig) {
        return CarrierApiFp(this.configuration).getAppCarrierList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    public getAppCarrierList_1(options?: RawAxiosRequestConfig) {
        return CarrierApiFp(this.configuration).getAppCarrierList_1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierApiPostAppCarrierDisableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    public postAppCarrierDisable(requestParameters: CarrierApiPostAppCarrierDisableRequest, options?: RawAxiosRequestConfig) {
        return CarrierApiFp(this.configuration).postAppCarrierDisable(requestParameters.carrierCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierApiPostAppCarrierEnableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    public postAppCarrierEnable(requestParameters: CarrierApiPostAppCarrierEnableRequest, options?: RawAxiosRequestConfig) {
        return CarrierApiFp(this.configuration).postAppCarrierEnable(requestParameters.carrierCode, options).then((request) => request(this.axios, this.basePath));
    }
}

